module.exports = __webpack_public_path__ + "img/camp_shirt_other6.3538967c.svg";